import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {ServiceDocumentPendingApprovalModel} from '../../models/service-document-pending-approval-model';
import {UserContextService} from '../../../../core/services/user-context.service';
import {UtilityService} from '../../../../shared/services/utility.service';
import {ServiceHttpService} from '../../services/services.http.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-modal-services-data-processing-agreement-new',
    templateUrl: './modal-services-data-processing-agreement-new.component.html',
    styleUrl: './modal-services-data-processing-agreement-new.component.scss'
})
export class ModalServicesDataProcessingAgreementNewComponent extends ModalDialogV3 implements AfterViewInit, OnInit {

    @ViewChildren('focusedButton') fb: any;
    @ViewChild('pdfIframe', {static: true, read: ElementRef}) pdfIframe: ElementRef;


    public static ActionEnum = {
        CONFIRM: 'CONFIRM',
        CANCEL: 'CANCEL'
    };

    private actionEnum = ModalServicesDataProcessingAgreementNewComponent.ActionEnum;


    public agreement: ServiceDocumentPendingApprovalModel;
    private blob: any;

    public initialized = false;
    public isError = false;


    isAgreed: boolean;


    constructor(private userContextService: UserContextService,
                private utilityService: UtilityService,
                private servicesHttpService: ServiceHttpService) {
        super();
    }


    public async ngOnInit() {


        try {
            this.agreement = this.modalParams?.model as ServiceDocumentPendingApprovalModel;
            if (!this.agreement?.fileContentBase64) {
                this.agreement = {
                    id: 5,
                    filename: 'agreement.pdf',
                    title: 'Data Processing Agreement',
                    documentType: 'DATA_PROCESSING_AGREEMENT',
                    fileContentBase64: '',
                    createdAt: new Date().toISOString(),
                };
            }
            console.log('OnINit this.agreement ', this.agreement);
            const pdfContent = this.agreement && this.agreement.fileContentBase64;
            this.blob = new Blob([this.utilityService.b64toBlob(pdfContent)], {type: 'application/pdf'});
            const agreementUrl = window.URL.createObjectURL(this.blob);
            this.pdfIframe.nativeElement.src = agreementUrl + '#toolbar=0';
            this.initialized = true;
        } catch (e) {
            this.isError = true;
            console.error(e);
        }


    }

    onCancelBtnClicked() {
        this.announceModelChanged({action: this.actionEnum.CANCEL});
        super.close();

    }

    async onConfirmBtnClicked() {
        console.log('onConfirmBtnClicked', this.agreement.id);

        try {
            if (this.agreement && this.agreement.id) {

                await this.servicesHttpService.acceptCouServicePartnersDocument(this.userContextService.getUserId(), this.agreement.id);
            } else {
                console.warn('dataProcessingAgreement is missing');
            }

            this.announceModelChanged({action: this.actionEnum.CONFIRM});
            super.close();
        } catch (e) {
            console.error(e);
            // the modal will not be closed to indicate the error to user
        }

    }

    ngAfterViewInit(): void {
        this.fb.first.nativeElement.focus();
    }

    onDownloadBtnClicked() {
        if (this.blob) {
            const data = window.URL.createObjectURL(this.blob);
            //
            const link = document.createElement('a');
            link.href = data;
            link.download = this.agreement.filename;

            if (!link.download) {
                link.download = 'agreement.pdf';
            }
            if (link.download.slice(-4).toLowerCase() !== '.pdf') {
                link.download += '.pdf';
            }

            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        } else {
            console.warn('DataProcessingAgreement pdf file not found');
        }


    }
}
